import { UI, HStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { Pressable } from 'native-base';
import { Control } from 'react-hook-form';
import { NativeSyntheticEvent, TextInputFocusEventData } from 'react-native';

import { useGlobalAssetContext } from '../../contexts';
import { useGlobalAssetController } from '../../hooks';

export const SearchTerm = () => {
  const isDisabledSearchInput = false;
  const { isMobile } = useGlobalAssetContext();
  const { formSearch, isValidSearch, handleClearSearchTerm, handleUpdateSearchTerm } =
    useGlobalAssetController();

  const handleInputBlur = (e: NativeSyntheticEvent<TextInputFocusEventData>) => {
    if (!e.nativeEvent.text) {
      handleClearSearchTerm();
    }
  };

  return (
    <HStack flex={1} space={Spacing['inline.xxxs']} py={Spacing['stack.nano']}>
      <UI.Input
        testID="product-search-input"
        placeholder="Pesquise por ativo"
        noValidate={true}
        name="searchTerm"
        onSubmitEditing={formSearch.handleSubmit(handleUpdateSearchTerm)}
        control={formSearch.control as unknown as Control}
        onBlur={handleInputBlur}
        isDisabled={isDisabledSearchInput}
        error={formSearch.formState.errors.searchTerm}
        autoComplete="off"
        variant="rounded"
        inputRightElement={
          <Pressable
            onPress={() => {
              isValidSearch ? handleClearSearchTerm() : null;
            }}
            pr={isValidSearch ? 3 : 4}
            isDisabled={isDisabledSearchInput}>
            <UI.Icon name={isValidSearch ? 'Close' : 'Search'} size="xxxs" />
          </Pressable>
        }
      />
      {!isMobile && (
        <UI.Button
          variant="primary"
          onPress={formSearch.handleSubmit(handleUpdateSearchTerm)}
          isDisabled={!isValidSearch || isDisabledSearchInput}>
          Buscar
        </UI.Button>
      )}
    </HStack>
  );
};
